export { Diploma } from './Diploma';
